<template lang="html">
   <div class="layout-sidenav">
      <div class="app-loader" v-show="showLoader">
         <div class="center-text">
            <div class="lds-facebook"><div></div><div></div><div></div></div>
            <div class="df-logo clearfix">
               <img src="/img/logo.png" alt="" class="logo f-l">
               <div class="title f-l">RUBiS</div>
            </div>
         </div>
      </div>

      <!-- modal components -->

      <div class="main-body">
         <TopNav />

         <div class="content clearfix">
            <Breadcrumb />

            <transition>
               <router-view/>
            </transition>
         </div>
         
         <div class="footer clearfix">
            <div class="left">
               &copy; {{new Date().getFullYear()}} <b>RUBiS LTD</b> all rights reserved
            </div>
            <div class="right">
               <router-link :to="{name: 'Dashboard'}" class="link">
                  Get Help
               </router-link>
               <!-- <router-link :to="{name: 'Dashboard'}" class="link">
                  Documentation
               </router-link> -->
            </div>
         </div>
      </div>

      <SideNav /> 
   </div>
</template>

<script>
   import MainComponents from '@/components/main'

   export default {
      // async beforeCreate(){
      //    let token = await $session.get('token')
      //    if(token == null||token == undefined){
      //       this.$router.push({name: 'LogIn'})
      //       $notify('warning', 'User Not Logged In', 'Log In to continue')
      //    }
      // },
      created(){
         let $this = this

         EventBus.$on('token:expired',(isToThrow)=>{
            if(isToThrow){
               $notify('warning', 'Token Expired', 'Log In to continue')
               $this.logOut()
            }
         })

         EventBus.$on('user:logout',()=>{
            $this.logOut()
         })

         EventBus.$on("loader:show", status => {
            EventBus.$emit('page:loading',!status)
            $this.showLoader = status;
         });

         EventBus.$on('actions:open',(payload) => {
            $this.showModal = true
         })
      },
      components: {
         ...MainComponents.components
      },
      data () {
         return {
            showLoader: true
            // showLoader: true
         }
      },
      methods: {
         getAction () {
            let action = {
               'ad_campaign': '',
            }
         },
         logOut(){
            $session.clear()
            this.$router.push({name: 'LogIn'})
         }
      },
      mounted(){

      }
   }
</script>

<style lang="scss">
.layout-sidenav{
   .app-loader{
      .lds-facebook{
         margin: 0 0 0 30px;
      }
      .center-text{
         .logo{
            width: auto;
            height: auto;
            max-height: 50px;
            max-width: 50px;
            float: left;
            margin: 10px 10px 0 0;
         }
         .title{
            margin: 23px 0 0 5px;
            font-size: 16px;
            line-height: 15px;
            height: 18px;
            padding: 3px 0 0 5px;
            color: $primary;
            border-left: solid 1px $primary;
         }
      }
   }
   .footer{
      padding: 20px 10px;
      font-size: 12px;
      margin: 50px 0 0 0;
      border-top: dashed 1px $border-grey;

      .left{
         float: left;
         padding: 0 0 0 15px;
      }
      .right{
         float: right;

         .link{
            margin: 0 10px;
            font-weight: 600;
         }
      }
   }
}
</style>